import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
import { offerAnchor, productName } from '../data/content';
import { recentPurchases } from '../data/purchases';
const FIRST_DELAY = 5000;
const VISIBLE_FOR = 5000;
const INTERVAL = 11000;
export function PurchasePopup() {
  const [index, setIndex] = useState<number | null>(null);
  useEffect(() => {
    let count = 0;
    let hideTimer: number | undefined;
    let interval: number | undefined;
    const show = () => {
      setIndex(count % recentPurchases.length);
      count += 1;
      hideTimer = window.setTimeout(() => setIndex(null), VISIBLE_FOR);
    };
    const first = window.setTimeout(() => {
      show();
      interval = window.setInterval(show, INTERVAL);
    }, FIRST_DELAY);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, []);
  const purchase = index === null ? null : recentPurchases[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-3 left-3 z-[60] md:bottom-6 md:left-6" data-id="element-236" data-mp="164egi9kqbgk9">
      <AnimatePresence data-id="element-237" data-mp="114tl294rpqca">
        {purchase && <motion.a key={index} href={offerAnchor} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[260px] items-center gap-3 rounded-xl border-[3px] border-amber-300 bg-berry-600 p-3 shadow-2xl shadow-plum-950/40 ring-2 ring-white" data-id="element-238" data-mp="1fw24g0i2ufgz">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-239" data-mp="s56hbgokg8g2">
              <ShoppingBagIcon className="h-5 w-5 text-berry-600" aria-hidden="true" data-id="element-240" data-mp="28jeu4jjjb3ei" />
            </span>
            <span className="min-w-0 text-left" data-id="element-241" data-mp="23klbydtayo80">
              <span className="block text-sm font-extrabold leading-tight text-white" data-id="element-242" data-mp="2aol50emjke3s">
                {purchase.name}{' '}
                <span className="font-semibold" data-id="element-243" data-mp="2fmv2ivvqnqsk">
                  from {purchase.city}, {purchase.country}
                </span>
              </span>
              <span className="mt-0.5 block text-xs text-white" data-id="element-244" data-mp="2kko6di9kk8po">just bought the {productName}</span>
              <span className="mt-0.5 block text-[10px] font-black uppercase tracking-wider text-blush-200" data-id="element-245" data-mp="2pjrcl61ackz8">
                {purchase.time}
              </span>
            </span>
          </motion.a>}
      </AnimatePresence>
    </div>;
}